var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMakecopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.44,
    height: 15.554,
    viewBox: "0 0 14.44 15.554",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11366",
    "data-name": "Path 11366",
    d: "M13.325,5.745l-.4-.442-.672,0h-1.53L9.017,3.594l-.484-.453H2.165l.623.583-.623-.583V14.8h4.31v2.158h9.5V8.371l-.444-.418ZM6.475,7.36v6.562H3.046v-9.9h5.12l.227.2L9.477,5.3h-3V7.358ZM15.1,14.9v1.174H7.358v-9.9h5.17l.175.188,2.208,2.208.187.178V14.9ZM16.475,4.149,15.341,5.281a.44.44,0,0,1-.622,0L13.586,4.148a.44.44,0,0,1,.622-.622l.378.378a1.667,1.667,0,0,0-1.663-1.623h-1a.44.44,0,1,1,0-.881h1a2.548,2.548,0,0,1,2.544,2.51l.386-.385a.441.441,0,0,1,.622.624Z",
    transform: "translate(-2.165 -1.4)",
    fill: "var(--mainColor)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakecopy);
export default __webpack_public_path__ + "static/media/makecopy.406516af9a191cbf3897e976407bd1cd.svg";
export { ForwardRef as ReactComponent };